import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Welcome = () => (
  <section className="py-16 sm:py-24 lg:py-32" data-testid="welcome-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -top-5 -left-5 w-full h-full rounded-3xl border border-[#D8B7B0]" aria-hidden="true" />
            <img
              src="/images/marypawpins/carly-three-dogs-autumn.jpg"
              alt="Carly with three dogs in an autumn woodland"
              className="relative rounded-3xl w-full aspect-[4/5] object-cover shadow-[0_20px_60px_rgba(41,42,38,0.12)]"
              data-testid="welcome-image"
            />
          </div>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2 lg:pl-6">
          <p className="eyebrow">A warm welcome</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#292A26] tracking-tight leading-tight mt-4" data-testid="welcome-heading">
            A little more personal.
          </h2>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-[#575953] max-w-2xl">
            Mary Pawpins is an Inverness pet-care business founded and run by Carly.
            With a regular walking client list of over 30, the focus is on building
            familiar relationships and providing care that fits around each animal,
            rather than a one-size-fits-all service.
          </p>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-[#575953] max-w-2xl">
            From group walks in the countryside to keeping pets comfortable at home
            while their owners are away, the aim is simple: reliable care, good
            communication, and animals who are happy to see Carly arrive.
          </p>
          <Link
            to="/about"
            data-testid="meet-carly-link"
            className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[#3F4A38] group"
          >
            Meet Carly
            <span className="w-9 h-9 rounded-full border border-[#3F4A38]/30 flex items-center justify-center group-hover:bg-[#3F4A38] group-hover:text-[#F7F4ED] transition-colors">
              <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
        </div>
      </div>
    </div>
  </section>
);
